import { useEffect, useState } from 'react'
import ApiService from '../../common/ApiCalls'
import { useFormik } from 'formik'
import * as yup from 'yup'

const useTemplateConfig = (
  onEditMode,
  setOnEditMode,
  setIsSnackbarOpen,
  setIsLoading
) => {
  const [templateOptions, setTemplateOptions] = useState([
    { template_name: '+ Add New' }
  ])
  const [templateOption, setTemplateOption] = useState(null)
  const [templateName, setTemplateName] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [footerDescription, setFooterDescription] = useState('')

  // Validation
  const validationSchema = yup.object({
    templateName: yup
      .string('Enter template name')
      .max(63, 'Template name should be of maximum 63 characters length')
      .required('Template name is required'),
    title: yup
      .string('Enter title')
      .max(64, 'Title should be of maximum 64 characters length')
      .required('Title is required'),
    description: yup
      .string('Enter description')
      .max(256, 'Description should be of maximum 256 characters length')
      .required('Description is required'),
    footerDescription: yup
      .string('Enter footer description')
      .max(128, 'Footer description should be of maximum 128 characters length')
      .required('Footer description is required')
  })

  const formik = useFormik({
    initialValues: {
      templateName: '',
      title: '',
      description: '',
      footerDescription: ''
    },
    validationSchema: validationSchema,
    onSubmit: values => {
      handleSave(
        values.templateName,
        values.title,
        values.description,
        values.footerDescription
      )
    }
  })

  const handleSave = async () => {
    setIsLoading(true)
    try {
      await ApiService().addWelcomeMessageTemplate(
        formik.values.templateName,
        formik.values.title,
        formik.values.description,
        formik.values.footerDescription
      )
      setIsSnackbarOpen({
        isOpen: true,
        severity: 'success',
        message: 'Information is successfully updated'
      })
      setIsLoading(false)
      setOnEditMode(false)
      getTemplateOptions()
    } catch (e) {
      setIsLoading(false)
      console.log(e)
    }
  }

  const handleCancel = () => {
    setOnEditMode(false)
  }

  const getTemplateOptions = async () => {
    const templateOptions = await ApiService().getAllTemplateOptions()
    setTemplateOptions([{ template_name: '+ Add New' }, ...templateOptions])
  }

  const setDefault = () => {
    const defaultIndex = templateOptions.findIndex(
      templateOption => templateOption.is_default
    )
    if (defaultIndex >= 0) {
      const defaultTemplate = templateOptions[defaultIndex]
      setTemplateOption(defaultTemplate)

      setTemplateName(defaultTemplate.template_name || '')
      setTitle(defaultTemplate.title || '')
      setDescription(defaultTemplate.description || '')
      setFooterDescription(defaultTemplate.footer || '')
    }
  }

  useEffect(() => {
    getTemplateOptions()
  }, [])

  useEffect(() => {
    if (templateOption) {
      formik.setFieldValue('templateName', templateOption.template_name || '')
      formik.setFieldValue('title', templateOption.title || '')
      formik.setFieldValue('description', templateOption.description || '')
      formik.setFieldValue('footerDescription', templateOption.footer || '')
    }

    if (!onEditMode) {
      setDefault()
    }
    // eslint-disable-next-line
  }, [templateOption, onEditMode])

  useEffect(() => {
    setDefault()
    // eslint-disable-next-line
  }, [templateOptions])

  return {
    title,
    setTitle,
    description,
    setDescription,
    footerDescription,
    setFooterDescription,
    handleCancel,
    templateName,
    setTemplateName,
    templateOption,
    setTemplateOption,
    templateOptions,
    formik
  }
}

export default useTemplateConfig
